var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchObject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 23.0005L19 19.0005M12 22.0005H5C3.89543 22.0005 3 21.105 3 20.0005V9.97862C3 9.36144 3.28495 8.77883 3.77212 8.39992L10.7721 2.95547C11.4943 2.39375 12.5057 2.39375 13.2279 2.95548L20.2279 8.39992C20.7151 8.77883 21 9.36144 21 9.97862V11.0005M20 16.0005C20 18.2096 18.2091 20.0005 16 20.0005C13.7909 20.0005 12 18.2096 12 16.0005C12 13.7913 13.7909 12.0005 16 12.0005C18.2091 12.0005 20 13.7913 20 16.0005Z",
    stroke: "#C10606",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchObject);
export default __webpack_public_path__ + "static/media/searchObject.fe441006199c087fbaa98c11d27ed97b.svg";
export { ForwardRef as ReactComponent };